import EventDispatcher = createjs.EventDispatcher;
import Event = createjs.Event;

export class LoadingItem extends EventDispatcher {
    public _isLoaded: boolean = false;

    constructor() {
        super();
        this.addEventListener(Event.COMPLETE, this.onLoadingComplete);
    }

    onLoadingComplete = (event:Event) => {
        this._isLoaded = true;
    };

    public get isLoaded() {
        return this._isLoaded;
    }
}
